<template>
  <router-link
    tag='div'
    v-if='product'
    :to='productRoute'
    class='un_producttile col-sm-4'>
    <div class='un_producttile_wrap'>
      <div class='row'>
        <div class='col-sm-12 un_producttile_image'>
          <img v-if='product.productshotimage_set.length' :src='product.productshotimage_set[0].original'>
          <img :src="emptyProdImage" v-else>
        </div>
      </div>
      <div class='row'>
        <div class='col-sm-12 un_producttile_title'>
          <h2 class='mar_t_1'>{{product.decoration.name}}</h2>
          <p><span class='published_indicator' :class='{published: product.is_available}'></span></p>
        </div>
      </div>
    </div>
  </router-link>
</template>
<script>
export default {
  props: {
    product: {
      type: Object,
      required: true,
      default: function () {
        return {}
      }
    }
  },
  computed: {
    productRoute () {
      if (this.product) {
        return {
          name: 'designer-view',
          params: {
            categoryId: this.$route.params.categoryId,
            itemId: this.$route.params.itemId,
            productId: this.product.id
          }
        }
      }
    },
    emptyProdImage () {
      return require('../../assets/empty_product.png')
    }
  }
}
</script>
<style lang='scss' scoped>
.un_producttile{
  position: relative;
  width: 40%;
  display: inline-block;
  .un_producttile_title{
    text-align: center;
    padding-bottom:1rem;
    h2{
      margin-bottom:0.25rem;
      transition: color 0.2s ease-in-out;
    }
    p{ margin:0; }
    .published_indicator{
      position: relative;
      display: block;
      width:1rem;
      height:1rem;
      border-radius: 50%;
      background-color:#dbdbdb;
      margin:0 auto;
      &.published{
        background-color: #24e87d;
      }
    }
  }
  .un_producttile_image{
    text-align: center;
    img{
      position: relative;
      width:auto;
      height:auto;
      max-width: 100%;
      max-height: 100%;
    }
  }
}
.un_producttile_wrap{
  background-position: top center;
  background-size: 100%;
  background-repeat: no-repeat;
  padding:1rem;
  cursor: pointer;
  transition: all 0.2s cubic-bezier(0.4, 0.0, 0.2, 1);
  &:hover{
    background-color:white;
    transform: scale(1.01) translate3d(0, 0, 0);
    h2{
      color:$c_pure_blue;
    }
  }
}
</style>



// WEBPACK FOOTER //
// uncommon-client/components/gold-admin/ProductTile.vue